/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCERTIFICATE = /* GraphQL */ `
  query GetCERTIFICATE($id: ID!) {
    getCERTIFICATE(id: $id) {
      id
      name
      certificateType
      parentCertificateId
      coverageType
      childCertificates {
        nextToken
        scannedCount
        __typename
      }
      clientVendorID
      clientID
      projectID
      certificateDate
      firstExp
      producerName
      producer
      producerAddress1
      producerAddress2
      producerCity
      producerState
      producerZip
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      insuredName
      insuredAddress1
      insuredAddress2
      insuredCity
      insuredState
      insuredZip
      descriptionOfOperation
      certificateHolder
      certificateHolderName
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      files
      supplementalCoiFiles
      acord25File
      acord25FileDate
      comments
      imported
      status
      previousId
      updatedAt
      createdAt
      initialCoverageRequirements
      initialDescriptionOfOperation
      overrides
      sentBy
      redirectedBy
      sentTo
      readBy
      additionalInformation
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      __typename
    }
  }
`;
export const listCERTIFICATES = /* GraphQL */ `
  query ListCERTIFICATES(
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCERTIFICATES(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByParent = /* GraphQL */ `
  query CertificateByParent(
    $parentCertificateId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByParent(
      parentCertificateId: $parentCertificateId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientVendor = /* GraphQL */ `
  query CertificateByClientVendor(
    $clientVendorID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientVendor(
      clientVendorID: $clientVendorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClient = /* GraphQL */ `
  query CertificateByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByCertificateDate = /* GraphQL */ `
  query CertificateByClientSortByCertificateDate(
    $clientID: ID!
    $certificateDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByCertificateDate(
      clientID: $clientID
      certificateDate: $certificateDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByInsured = /* GraphQL */ `
  query CertificateByClientSortByInsured(
    $clientID: ID!
    $insured: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByInsured(
      clientID: $clientID
      insured: $insured
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByProducer = /* GraphQL */ `
  query CertificateByClientSortByProducer(
    $clientID: ID!
    $producer: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByProducer(
      clientID: $clientID
      producer: $producer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByUpdatedAt = /* GraphQL */ `
  query CertificateByClientSortByUpdatedAt(
    $clientID: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByUpdatedAt(
      clientID: $clientID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByFirstExp = /* GraphQL */ `
  query CertificateByClientSortByFirstExp(
    $clientID: ID!
    $firstExp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByFirstExp(
      clientID: $clientID
      firstExp: $firstExp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByClientSortByCreatedAt = /* GraphQL */ `
  query CertificateByClientSortByCreatedAt(
    $clientID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByClientSortByCreatedAt(
      clientID: $clientID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByProject = /* GraphQL */ `
  query CertificateByProject(
    $projectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByProject(
      projectID: $projectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const certificateByFirstExp = /* GraphQL */ `
  query CertificateByFirstExp(
    $firstExp: AWSDate!
    $sortDirection: ModelSortDirection
    $filter: ModelCERTIFICATEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    certificateByFirstExp(
      firstExp: $firstExp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
export const getCERTIFICATECOVERAGE = /* GraphQL */ `
  query GetCERTIFICATECOVERAGE($id: ID!) {
    getCERTIFICATECOVERAGE(id: $id) {
      id
      name
      certificateID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      overrides
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCERTIFICATECOVERAGES = /* GraphQL */ `
  query ListCERTIFICATECOVERAGES(
    $filter: ModelCERTIFICATECOVERAGEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCERTIFICATECOVERAGES(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        certificateID
        insuranceType
        insuranceForm
        aggregateAppliesPer
        coveredProperty
        additionalInsured
        subrogationWaiver
        deductible
        retention
        exclusion
        limits
        overrides
        limitPerStatute
        policyEff
        policyExp
        policyNumber
        insurerLetter
        selectedCoverage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVENDORCOVERAGE = /* GraphQL */ `
  query GetVENDORCOVERAGE($id: ID!) {
    getVENDORCOVERAGE(id: $id) {
      id
      name
      clientVendorID
      categoryID
      clientCoverageID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVENDORCOVERAGES = /* GraphQL */ `
  query ListVENDORCOVERAGES(
    $filter: ModelVENDORCOVERAGEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVENDORCOVERAGES(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        clientVendorID
        categoryID
        clientCoverageID
        insuranceType
        insuranceForm
        aggregateAppliesPer
        coveredProperty
        additionalInsured
        subrogationWaiver
        deductible
        retention
        exclusion
        limits
        limitPerStatute
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCLIENTCOVERAGE = /* GraphQL */ `
  query GetCLIENTCOVERAGE($id: ID!) {
    getCLIENTCOVERAGE(id: $id) {
      id
      name
      clientID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCLIENTCOVERAGES = /* GraphQL */ `
  query ListCLIENTCOVERAGES(
    $filter: ModelCLIENTCOVERAGEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCLIENTCOVERAGES(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        clientID
        insuranceType
        insuranceForm
        aggregateAppliesPer
        coveredProperty
        additionalInsured
        subrogationWaiver
        deductible
        retention
        exclusion
        limits
        limitPerStatute
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPROJECT = /* GraphQL */ `
  query GetPROJECT($id: ID!) {
    getPROJECT(id: $id) {
      id
      name
      startDate
      endDate
      description
      status
      clientID
      requiredCoverages
      requiredDescriptionOfOperation
      vendors {
        nextToken
        __typename
      }
      isDefault
      address
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPROJECTS = /* GraphQL */ `
  query ListPROJECTS(
    $filter: ModelPROJECTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPROJECTS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startDate
        endDate
        description
        status
        clientID
        requiredCoverages
        requiredDescriptionOfOperation
        isDefault
        address
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPROJECTVENDORS = /* GraphQL */ `
  query GetPROJECTVENDORS($id: ID!) {
    getPROJECTVENDORS(id: $id) {
      id
      projectID
      PROJECT {
        id
        name
        startDate
        endDate
        description
        status
        clientID
        requiredCoverages
        requiredDescriptionOfOperation
        isDefault
        address
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      clientVendorID
      clientVendor {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPROJECTVENDORS = /* GraphQL */ `
  query ListPROJECTVENDORS(
    $filter: ModelPROJECTVENDORSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPROJECTVENDORS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        clientVendorID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCLIENTVENDORS = /* GraphQL */ `
  query GetCLIENTVENDORS($id: ID!) {
    getCLIENTVENDORS(id: $id) {
      id
      starred
      clientID
      vendor {
        id
        name
        useEntityName
        entityName
        email
        additionalEmails
        ein
        phone
        logo
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        vENDORInsuranceAgentId
        __typename
      }
      vendorID
      status
      notificationStatus
      vendorCoverages {
        nextToken
        __typename
      }
      certificates {
        nextToken
        scannedCount
        __typename
      }
      projects {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCLIENTVENDORS = /* GraphQL */ `
  query ListCLIENTVENDORS(
    $filter: ModelCLIENTVENDORSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCLIENTVENDORS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientVendorsByClient = /* GraphQL */ `
  query ClientVendorsByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCLIENTVENDORSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientVendorsByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        starred
        clientID
        vendorID
        status
        notificationStatus
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getINSURANCEAGENT = /* GraphQL */ `
  query GetINSURANCEAGENT($id: ID!) {
    getINSURANCEAGENT(id: $id) {
      id
      name
      phone
      email
      address1
      address2
      city
      state
      zip
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listINSURANCEAGENTS = /* GraphQL */ `
  query ListINSURANCEAGENTS(
    $filter: ModelINSURANCEAGENTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listINSURANCEAGENTS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        phone
        email
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVENDOR = /* GraphQL */ `
  query GetVENDOR($id: ID!) {
    getVENDOR(id: $id) {
      id
      name
      useEntityName
      entityName
      email
      additionalEmails
      ein
      phone
      logo
      address1
      address2
      city
      state
      zip
      insuranceAgent {
        id
        name
        phone
        email
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      vENDORInsuranceAgentId
      __typename
    }
  }
`;
export const listVENDORS = /* GraphQL */ `
  query ListVENDORS(
    $filter: ModelVENDORFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVENDORS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        useEntityName
        entityName
        email
        additionalEmails
        ein
        phone
        logo
        address1
        address2
        city
        state
        zip
        createdAt
        updatedAt
        vENDORInsuranceAgentId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUSER = /* GraphQL */ `
  query GetUSER($id: ID!) {
    getUSER(id: $id) {
      id
      firstName
      lastName
      email
      role
      organizationID
      userOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      status
      assignedVendors
      lastLoginAt
      lastActiveAt
      cognitoCreatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUSERS = /* GraphQL */ `
  query ListUSERS(
    $filter: ModelUSERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUSERS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        role
        organizationID
        status
        assignedVendors
        lastLoginAt
        lastActiveAt
        cognitoCreatedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelUSERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        role
        organizationID
        status
        assignedVendors
        lastLoginAt
        lastActiveAt
        cognitoCreatedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByOrganization = /* GraphQL */ `
  query UserByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUSERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        role
        organizationID
        status
        assignedVendors
        lastLoginAt
        lastActiveAt
        cognitoCreatedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCLIENT = /* GraphQL */ `
  query GetCLIENT($id: ID!) {
    getCLIENT(id: $id) {
      id
      organizationID
      agencyOrganizationID
      mode
      clientOrganization {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      clientVendors {
        nextToken
        __typename
      }
      clientProjects {
        nextToken
        __typename
      }
      clientCoverages {
        nextToken
        __typename
      }
      templates
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCLIENTS = /* GraphQL */ `
  query ListCLIENTS(
    $filter: ModelCLIENTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCLIENTS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationID
        agencyOrganizationID
        mode
        templates
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientByOrganizationID = /* GraphQL */ `
  query ClientByOrganizationID(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCLIENTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientByOrganizationID(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        agencyOrganizationID
        mode
        templates
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientByAgencyOrganizationID = /* GraphQL */ `
  query ClientByAgencyOrganizationID(
    $agencyOrganizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCLIENTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientByAgencyOrganizationID(
      agencyOrganizationID: $agencyOrganizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        agencyOrganizationID
        mode
        templates
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getORGANIZATION = /* GraphQL */ `
  query GetORGANIZATION($id: ID!) {
    getORGANIZATION(id: $id) {
      id
      name
      vendorLabel
      projectLabel
      clientLabel
      certificateHolder
      certificateHolderAddress1
      certificateHolderAddress2
      certificateHolderCity
      certificateHolderState
      certificateHolderZip
      themeColor
      logo
      isAgency
      useDefaultProject
      usePrimaryNotificationEmailAddress
      primaryNotificationEmailAddress
      tableRowsPerPage
      organizationUsers {
        nextToken
        __typename
      }
      email
      type
      adminName
      adminEmail
      phone
      address1
      address2
      city
      state
      zip
      website
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listORGANIZATIONS = /* GraphQL */ `
  query ListORGANIZATIONS(
    $filter: ModelORGANIZATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listORGANIZATIONS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        vendorLabel
        projectLabel
        clientLabel
        certificateHolder
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        themeColor
        logo
        isAgency
        useDefaultProject
        usePrimaryNotificationEmailAddress
        primaryNotificationEmailAddress
        tableRowsPerPage
        email
        type
        adminName
        adminEmail
        phone
        address1
        address2
        city
        state
        zip
        website
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getANTHROPICSETTINGS = /* GraphQL */ `
  query GetANTHROPICSETTINGS($id: ID!) {
    getANTHROPICSETTINGS(id: $id) {
      id
      organizationID
      clientID
      enabled
      defaultModel
      extractionStrategy
      fallbackToOCR
      confidenceThreshold
      maxTokens
      temperature
      enableFieldConfidence
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const listANTHROPICSETTINGS = /* GraphQL */ `
  query ListANTHROPICSETTINGS(
    $filter: ModelANTHROPICSETTINGSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listANTHROPICSETTINGS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        clientID
        enabled
        defaultModel
        extractionStrategy
        fallbackToOCR
        confidenceThreshold
        maxTokens
        temperature
        enableFieldConfidence
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const anthropicSettingsByOrganization = /* GraphQL */ `
  query AnthropicSettingsByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelANTHROPICSETTINGSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    anthropicSettingsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        clientID
        enabled
        defaultModel
        extractionStrategy
        fallbackToOCR
        confidenceThreshold
        maxTokens
        temperature
        enableFieldConfidence
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const anthropicSettingsByClient = /* GraphQL */ `
  query AnthropicSettingsByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelANTHROPICSETTINGSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    anthropicSettingsByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationID
        clientID
        enabled
        defaultModel
        extractionStrategy
        fallbackToOCR
        confidenceThreshold
        maxTokens
        temperature
        enableFieldConfidence
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEMAILNOTIFICATIONS = /* GraphQL */ `
  query GetEMAILNOTIFICATIONS($id: ID!) {
    getEMAILNOTIFICATIONS(id: $id) {
      id
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEMAILNOTIFICATIONS = /* GraphQL */ `
  query ListEMAILNOTIFICATIONS(
    $filter: ModelEMAILNOTIFICATIONSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEMAILNOTIFICATIONS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSCHEDULEDEMAILS = /* GraphQL */ `
  query GetSCHEDULEDEMAILS($id: ID!) {
    getSCHEDULEDEMAILS(id: $id) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSCHEDULEDEMAILS = /* GraphQL */ `
  query ListSCHEDULEDEMAILS(
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSCHEDULEDEMAILS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const scheduledEmailsByDate = /* GraphQL */ `
  query ScheduledEmailsByDate(
    $scheduledDate: AWSDateTime!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByDate(
      scheduledDate: $scheduledDate
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const scheduledEmailsByClient = /* GraphQL */ `
  query ScheduledEmailsByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const scheduledEmailsByVendor = /* GraphQL */ `
  query ScheduledEmailsByVendor(
    $vendorID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByVendor(
      vendorID: $vendorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const scheduledEmailsByCertificate = /* GraphQL */ `
  query ScheduledEmailsByCertificate(
    $certificateID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByCertificate(
      certificateID: $certificateID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getACORD25SCAN = /* GraphQL */ `
  query GetACORD25SCAN($id: ID!) {
    getACORD25SCAN(id: $id) {
      id
      certificateID
      certificateDate
      producer
      producerContactName
      producerPhone
      producerFax
      producerEmail
      insured
      descriptionOfOperation
      certificateHolder
      insurerA
      insurerB
      insurerC
      insurerD
      insurerE
      insurerF
      insurerANAIC
      insurerBNAIC
      insurerCNAIC
      insurerDNAIC
      insurerENAIC
      insurerFNAIC
      coverages {
        nextToken
        __typename
      }
      acord25File
      status
      scanStage
      uploadLink
      uploaderName
      uploaderEmail
      scanError
      scanConfidence
      fieldConfidence
      extractionMethod
      extractionModel
      extractionConfidence
      extractionMetadata
      reprocessedCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listACORD25SCANS = /* GraphQL */ `
  query ListACORD25SCANS(
    $filter: ModelACORD25SCANFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listACORD25SCANS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        certificateID
        certificateDate
        producer
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        descriptionOfOperation
        certificateHolder
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        acord25File
        status
        scanStage
        uploadLink
        uploaderName
        uploaderEmail
        scanError
        scanConfidence
        fieldConfidence
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const acord25ScanByCertificate = /* GraphQL */ `
  query Acord25ScanByCertificate(
    $certificateID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelACORD25SCANFilterInput
    $limit: Int
    $nextToken: String
  ) {
    acord25ScanByCertificate(
      certificateID: $certificateID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        certificateID
        certificateDate
        producer
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        descriptionOfOperation
        certificateHolder
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        acord25File
        status
        scanStage
        uploadLink
        uploaderName
        uploaderEmail
        scanError
        scanConfidence
        fieldConfidence
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getACORD25SCANCOVERAGE = /* GraphQL */ `
  query GetACORD25SCANCOVERAGE($id: ID!) {
    getACORD25SCANCOVERAGE(id: $id) {
      id
      name
      acord25ScanID
      insuranceType
      insuranceForm
      aggregateAppliesPer
      coveredProperty
      additionalInsured
      subrogationWaiver
      deductible
      retention
      exclusion
      limits
      limitPerStatute
      policyEff
      policyExp
      policyNumber
      insurerLetter
      selectedCoverage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listACORD25SCANCOVERAGES = /* GraphQL */ `
  query ListACORD25SCANCOVERAGES(
    $filter: ModelACORD25SCANCOVERAGEFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listACORD25SCANCOVERAGES(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        acord25ScanID
        insuranceType
        insuranceForm
        aggregateAppliesPer
        coveredProperty
        additionalInsured
        subrogationWaiver
        deductible
        retention
        exclusion
        limits
        limitPerStatute
        policyEff
        policyExp
        policyNumber
        insurerLetter
        selectedCoverage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getACTIVITY = /* GraphQL */ `
  query GetACTIVITY($id: ID!) {
    getACTIVITY(id: $id) {
      id
      entity
      entityID
      userFullName
      userID
      action
      field
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listACTIVITIES = /* GraphQL */ `
  query ListACTIVITIES(
    $filter: ModelACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listACTIVITIES(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        entity
        entityID
        userFullName
        userID
        action
        field
        value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activityByEntityID = /* GraphQL */ `
  query ActivityByEntityID(
    $entityID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activityByEntityID(
      entityID: $entityID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entity
        entityID
        userFullName
        userID
        action
        field
        value
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNOTIFICATION = /* GraphQL */ `
  query GetNOTIFICATION($id: ID!) {
    getNOTIFICATION(id: $id) {
      id
      type
      status
      title
      message
      userID
      organizationID
      certificateID
      vendorID
      clientID
      documentRequestID
      uploadCount
      uploaderName
      uploadedFiles
      metadata
      readAt
      archivedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNOTIFICATIONS = /* GraphQL */ `
  query ListNOTIFICATIONS(
    $filter: ModelNOTIFICATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNOTIFICATIONS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        status
        title
        message
        userID
        organizationID
        certificateID
        vendorID
        clientID
        documentRequestID
        uploadCount
        uploaderName
        uploadedFiles
        metadata
        readAt
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByUser = /* GraphQL */ `
  query NotificationsByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNOTIFICATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        status
        title
        message
        userID
        organizationID
        certificateID
        vendorID
        clientID
        documentRequestID
        uploadCount
        uploaderName
        uploadedFiles
        metadata
        readAt
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByOrganization = /* GraphQL */ `
  query NotificationsByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelNOTIFICATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        status
        title
        message
        userID
        organizationID
        certificateID
        vendorID
        clientID
        documentRequestID
        uploadCount
        uploaderName
        uploadedFiles
        metadata
        readAt
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByCertificate = /* GraphQL */ `
  query NotificationsByCertificate(
    $certificateID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelNOTIFICATIONFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByCertificate(
      certificateID: $certificateID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        status
        title
        message
        userID
        organizationID
        certificateID
        vendorID
        clientID
        documentRequestID
        uploadCount
        uploaderName
        uploadedFiles
        metadata
        readAt
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFILECABINETFOLDER = /* GraphQL */ `
  query GetFILECABINETFOLDER($id: ID!) {
    getFILECABINETFOLDER(id: $id) {
      id
      name
      description
      parentFolderID
      clientID
      organizationID
      createdBy
      parentFolder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      subFolders {
        nextToken
        __typename
      }
      folderItems {
        nextToken
        __typename
      }
      sortOrder
      depth
      itemCount
      lastActivityAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFILECABINETFOLDERS = /* GraphQL */ `
  query ListFILECABINETFOLDERS(
    $filter: ModelFILECABINETFOLDERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFILECABINETFOLDERS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const foldersByParent = /* GraphQL */ `
  query FoldersByParent(
    $parentFolderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETFOLDERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    foldersByParent(
      parentFolderID: $parentFolderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const foldersByClient = /* GraphQL */ `
  query FoldersByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETFOLDERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    foldersByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const foldersByOrganization = /* GraphQL */ `
  query FoldersByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETFOLDERFilterInput
    $limit: Int
    $nextToken: String
  ) {
    foldersByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFILECABINETITEM = /* GraphQL */ `
  query GetFILECABINETITEM($id: ID!) {
    getFILECABINETITEM(id: $id) {
      id
      folderID
      folder {
        id
        name
        description
        parentFolderID
        clientID
        organizationID
        createdBy
        sortOrder
        depth
        itemCount
        lastActivityAt
        createdAt
        updatedAt
        __typename
      }
      certificateID
      documentID
      documentType
      documentName
      clientID
      addedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFILECABINETITEMS = /* GraphQL */ `
  query ListFILECABINETITEMS(
    $filter: ModelFILECABINETITEMFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFILECABINETITEMS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const itemsByFolder = /* GraphQL */ `
  query ItemsByFolder(
    $folderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETITEMFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByFolder(
      folderID: $folderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const itemsByCertificate = /* GraphQL */ `
  query ItemsByCertificate(
    $certificateID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETITEMFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByCertificate(
      certificateID: $certificateID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const itemsByDocument = /* GraphQL */ `
  query ItemsByDocument(
    $documentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETITEMFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByDocument(
      documentID: $documentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const itemsByClient = /* GraphQL */ `
  query ItemsByClient(
    $clientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETITEMFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderID
        certificateID
        documentID
        documentType
        documentName
        clientID
        addedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFILECABINETACTIVITY = /* GraphQL */ `
  query GetFILECABINETACTIVITY($id: ID!) {
    getFILECABINETACTIVITY(id: $id) {
      id
      action
      folderID
      itemID
      itemType
      itemName
      performedBy
      details
      clientID
      organizationID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFILECABINETACTIVITIES = /* GraphQL */ `
  query ListFILECABINETACTIVITIES(
    $filter: ModelFILECABINETACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFILECABINETACTIVITIES(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        action
        folderID
        itemID
        itemType
        itemName
        performedBy
        details
        clientID
        organizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByFolder = /* GraphQL */ `
  query ActivitiesByFolder(
    $folderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByFolder(
      folderID: $folderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        action
        folderID
        itemID
        itemType
        itemName
        performedBy
        details
        clientID
        organizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByClient = /* GraphQL */ `
  query ActivitiesByClient(
    $clientID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByClient(
      clientID: $clientID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        action
        folderID
        itemID
        itemType
        itemName
        performedBy
        details
        clientID
        organizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByOrganization = /* GraphQL */ `
  query ActivitiesByOrganization(
    $organizationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFILECABINETACTIVITYFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByOrganization(
      organizationID: $organizationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        action
        folderID
        itemID
        itemType
        itemName
        performedBy
        details
        clientID
        organizationID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDOCUMENTREQUEST = /* GraphQL */ `
  query GetDOCUMENTREQUEST($id: ID!) {
    getDOCUMENTREQUEST(id: $id) {
      id
      clientID
      clientVendorID
      projectID
      requestType
      categories {
        category
        description
        required
        __typename
      }
      requestedBy
      requestedByEmail
      requestedAt
      uploadToken
      tokenUsed
      tokenExpiresAt
      uploadedAt
      status
      emailSentAt
      emailReadAt
      emailOpenCount
      vendorEmail
      vendorName
      clientName
      notes
      associatedCertificateIds
      certificateDetails
      totalFilesRequested
      totalFilesUploaded
      uploads {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDOCUMENTREQUESTS = /* GraphQL */ `
  query ListDOCUMENTREQUESTS(
    $filter: ModelDOCUMENTREQUESTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDOCUMENTREQUESTS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentRequestByClient = /* GraphQL */ `
  query DocumentRequestByClient(
    $clientID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTREQUESTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentRequestByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentRequestByVendor = /* GraphQL */ `
  query DocumentRequestByVendor(
    $clientVendorID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTREQUESTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentRequestByVendor(
      clientVendorID: $clientVendorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentRequestByProject = /* GraphQL */ `
  query DocumentRequestByProject(
    $projectID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTREQUESTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentRequestByProject(
      projectID: $projectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentRequestByToken = /* GraphQL */ `
  query DocumentRequestByToken(
    $uploadToken: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTREQUESTFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentRequestByToken(
      uploadToken: $uploadToken
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDOCUMENTUPLOAD = /* GraphQL */ `
  query GetDOCUMENTUPLOAD($id: ID!) {
    getDOCUMENTUPLOAD(id: $id) {
      id
      documentRequestID
      documentRequest {
        id
        clientID
        clientVendorID
        projectID
        requestType
        requestedBy
        requestedByEmail
        requestedAt
        uploadToken
        tokenUsed
        tokenExpiresAt
        uploadedAt
        status
        emailSentAt
        emailReadAt
        emailOpenCount
        vendorEmail
        vendorName
        clientName
        notes
        associatedCertificateIds
        certificateDetails
        totalFilesRequested
        totalFilesUploaded
        createdAt
        updatedAt
        __typename
      }
      clientID
      clientVendorID
      category
      fileName
      fileSize
      fileType
      s3Key
      s3Bucket
      annotation
      uploadedAt
      uploadedBy
      status
      validationStatus
      validationNotes
      validatedBy
      validatedAt
      previewUrl
      reviewedBy
      reviewedAt
      reviewNotes
      isDeleted
      deletedAt
      deletedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDOCUMENTUPLOADS = /* GraphQL */ `
  query ListDOCUMENTUPLOADS(
    $filter: ModelDOCUMENTUPLOADFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDOCUMENTUPLOADS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        documentRequestID
        clientID
        clientVendorID
        category
        fileName
        fileSize
        fileType
        s3Key
        s3Bucket
        annotation
        uploadedAt
        uploadedBy
        status
        validationStatus
        validationNotes
        validatedBy
        validatedAt
        previewUrl
        reviewedBy
        reviewedAt
        reviewNotes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentUploadByRequest = /* GraphQL */ `
  query DocumentUploadByRequest(
    $documentRequestID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTUPLOADFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentUploadByRequest(
      documentRequestID: $documentRequestID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentRequestID
        clientID
        clientVendorID
        category
        fileName
        fileSize
        fileType
        s3Key
        s3Bucket
        annotation
        uploadedAt
        uploadedBy
        status
        validationStatus
        validationNotes
        validatedBy
        validatedAt
        previewUrl
        reviewedBy
        reviewedAt
        reviewNotes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentUploadByClient = /* GraphQL */ `
  query DocumentUploadByClient(
    $clientID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTUPLOADFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentUploadByClient(
      clientID: $clientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentRequestID
        clientID
        clientVendorID
        category
        fileName
        fileSize
        fileType
        s3Key
        s3Bucket
        annotation
        uploadedAt
        uploadedBy
        status
        validationStatus
        validationNotes
        validatedBy
        validatedAt
        previewUrl
        reviewedBy
        reviewedAt
        reviewNotes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const documentUploadByVendor = /* GraphQL */ `
  query DocumentUploadByVendor(
    $clientVendorID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDOCUMENTUPLOADFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentUploadByVendor(
      clientVendorID: $clientVendorID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentRequestID
        clientID
        clientVendorID
        category
        fileName
        fileSize
        fileType
        s3Key
        s3Bucket
        annotation
        uploadedAt
        uploadedBy
        status
        validationStatus
        validationNotes
        validatedBy
        validatedAt
        previewUrl
        reviewedBy
        reviewedAt
        reviewNotes
        isDeleted
        deletedAt
        deletedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActiveCertificates = /* GraphQL */ `
  query GetActiveCertificates(
    $clientID: ID!
    $indexName: ACTIVECERTIFICATESNDEXNAME
    $status: String
    $statusFilter: String
    $nextToken: String
    $limit: Int
    $sortDirection: String
    $filter: CertificateFilterInput
  ) {
    getActiveCertificates(
      clientID: $clientID
      indexName: $indexName
      status: $status
      statusFilter: $statusFilter
      nextToken: $nextToken
      limit: $limit
      sortDirection: $sortDirection
      filter: $filter
    ) {
      items {
        id
        name
        certificateType
        parentCertificateId
        coverageType
        clientVendorID
        clientID
        projectID
        certificateDate
        firstExp
        producerName
        producer
        producerAddress1
        producerAddress2
        producerCity
        producerState
        producerZip
        producerContactName
        producerPhone
        producerFax
        producerEmail
        insured
        insuredName
        insuredAddress1
        insuredAddress2
        insuredCity
        insuredState
        insuredZip
        descriptionOfOperation
        certificateHolder
        certificateHolderName
        certificateHolderAddress1
        certificateHolderAddress2
        certificateHolderCity
        certificateHolderState
        certificateHolderZip
        insurerA
        insurerB
        insurerC
        insurerD
        insurerE
        insurerF
        insurerANAIC
        insurerBNAIC
        insurerCNAIC
        insurerDNAIC
        insurerENAIC
        insurerFNAIC
        files
        supplementalCoiFiles
        acord25File
        acord25FileDate
        comments
        imported
        status
        previousId
        updatedAt
        createdAt
        initialCoverageRequirements
        initialDescriptionOfOperation
        overrides
        sentBy
        redirectedBy
        sentTo
        readBy
        additionalInformation
        extractionMethod
        extractionModel
        extractionConfidence
        extractionMetadata
        reprocessedCount
        __typename
      }
      nextToken
      scannedCount
      __typename
    }
  }
`;
